module.exports = __webpack_public_path__ + "img/cfa3035f4e18e94566297a7080d13a40.80d4050f.jpg";